module.exports = __webpack_public_path__ + "img/pic16.b7c1c95f.png";